import React, { useEffect, useCallback, useState, useRef } from "react";
import { connect } from "react-redux";
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import { withSnackbar } from 'notistack';
import moment from 'moment';
import { FormattedMessage, injectIntl } from "react-intl";
import ContractPrice from "../../../../widgets/ContractPrice";
import MultipleContractPrice from "../../../../widgets/MultipleContractPrice";
import ContractParties from "../../../../widgets/ContractParties";
import ContractTimeline from "../../../../widgets/ContractTimeline";
import ContractNextPayment from "../../../../widgets/ContractNextPayment";
import ProgramTimeline from "../../../../widgets/ProgramTimeline";
import ContractPayments from "../../../../widgets/ContractPayments";
import MultipleContractPayments from "../../../../widgets/MultipleContractPayments";
import ContractActions from "../../../../widgets/ContractActions";
import TemplateHelper from '../../../../Templates/TemplateHelper';
import { adjustContractTemplate } from "../../../../Templates/TemplateAdjust";
import { Puck, useGetPuck } from "@measured/puck";
import "@measured/puck/puck.css";
import Common from '../../../../shared/common';
import DonutChart2 from "../../../../widgets/DonutChart2";
import ConrtractCalendarAction from "../../../../widgets/ConrtractCalendarAction";
import DefaultDashboardDesign from "../../../../Templates/DefaultDashboardDesign";
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { useSnackbar } from 'notistack';

// const withPuckProps = (Component) => {
//   function ComponentWithPuckProp(props) {
//     const getPuck = useGetPuck();
//     return (
//       <Component
//         {...props}
//         getPuck={getPuck}
//       />
//     );
//   }

//   return ComponentWithPuckProp;
// }

export const dummyActions = {
    items: [
        {
            duedate: moment().add(1, 'weeks').toDate(),
            type: 'WF_1',
            resolvingworkflowid: 1,
            sourcereferenceid: "EW-00001",
            resolvingreferenceid: "EW-00001",
            groupcategory: 1,
            subject: "Early Warning 1",
        },
    ],
    SUPPLIER: { items: [1, 2, 3] },
    PM: { items: [1, 2] },
    SUPERVISOR: { items: [1, 2, 3, 4, 5, 6] },
    CLIENT: { items: [7, 8, 9, 10, 11, 12, 13, 14, 15] },
};

export const dummyDashboard = {
    lastprogramaccepted: moment().subtract(2, 'weeks').toDate(),
    lastprogramsubmitted: moment().subtract(1, 'weeks').toDate(),
    riskverylow: 5,
    risklow: 10,
    riskpriority: 3,
    riskhigh: 1,
    riskveryhigh: 0,
    earlywarningcontractorraised: 4,
    earlywarningpmraised: 2,
    earlywarningclientraised: 1,
    compeventclientraised: 3,
    compeventpmraised: 2,
    compeventsupplierraised: 1,
    compeventcontractorraised: 8,
    assessmentmade: 6,
    quoteimplemented: 4,
}
export const dummyContract = {
    contractid: 0,
    deleted: 0,
    name: "Dummy Contract",
    startdate: moment().subtract(1, 'months').toDate(),
    completedate: moment().add(11, 'months').toDate(),
    completiondate: moment().add(12, 'months').toDate(),
    actualcompletiondate: moment().add(13, 'months').toDate(),
    defectsdate: moment().add(5, 'months').toDate(),
    expectedcompletiondate: moment().add(12, 'months').toDate(),
    recordstatus: 1,
    partystructure: 3,//ALL
    contracttype: "DUMMY",
    employercompanyid: 1,
    supervisorcompanyid: 1,
    contractorcompanyid: 1,
    pmcompanyid: 1,
    currency: 'GBP',
    currencyoptions: [
        { currency: 'GBP' },
    ],
    designatedUsers: {
        pm: { user: "Steve Webley", company: "Built Intelligence", usercompany: "Built Intelligence" },
        supplier: { user: "Chris Corr", company: "Built Intelligence", usercompany: "Built Intelligence" },
        supervisor: { user: "Adrian von Plato", company: "Built Intelligence", usercompany: "Built Intelligence" },
        employer: { user: "Steve Webley", company: "Built Intelligence", usercompany: "Built Intelligence" }
    }
}
const defaultCurrencyCode = 'GBP';

export const getPuckDashboardRenderer = (props) => {
    const config = {
        categories: {

            layout: {
                components: [
                    "GRD_4CM_NOPAD",
                    "GRD_3CM_NOPAD",
                    "GRD_2CM_NOPAD",
                    "GRD_4CN_2CM_NOPAD",
                    "GRD_4CW_2CN_NOPAD",
                    "GRD_4CW_2CN",
                    "GRD_2Cx2C_M",
                    "GRD_2CW",
                    "GRD_2CN"],
                title: "Layout",
            },
            infoPanel: {
                components: ["INFO_ContractParties", "INFO_ContractPrice", "INFO_MultipleContractPrice", "INFO_ContractTimeline", "INFO_ProgramTimeline", "INFO_ContractPayments", "INFO_MultipleContractPayments", "INFO_ContractActions","INFO_ContractNextPaymentActions"],
                title: "Info Panels",
            },
            doughnutCharts: {
                components: ["CHART_EW", "CHART_EWRisk", "CHART_CEN", "CHART_CENImplemented"],
                title: "Doughnut Charts",
            },
            other: {
                components: ["ContractName", "ContractCalendar"],
                title: "Other",
            }
        },
        components: {
            GRD_4CM_NOPAD: {
                label: "GRD 4C Middle NOPAD",

                fields: {
                    slot1: {
                        type: "slot",
                        // allow: ["NEW_ContractParties", "NEW_ContractPrice", "NEW_ContractTimeline", "NEW_ProgramTimeline", "NEW_ContractPayments", "NEW_ContractActions"],
                    },
                    slot2: {
                        type: "slot",
                        // allow: ["NEW_ContractParties", "NEW_ContractPrice", "NEW_ContractTimeline", "NEW_ProgramTimeline", "NEW_ContractPayments", "NEW_ContractActions"],
                    },
                    slot3: {
                        type: "slot",
                        // allow: ["NEW_ContractParties", "NEW_ContractPrice", "NEW_ContractTimeline", "NEW_ProgramTimeline", "NEW_ContractPayments", "NEW_ContractActions"],
                    },
                    slot4: {
                        type: "slot",
                        // allow: ["NEW_ContractParties", "NEW_ContractPrice", "NEW_ContractTimeline", "NEW_ProgramTimeline", "NEW_ContractPayments", "NEW_ContractActions"],
                    },
                },
                render: ({ slot1: Slot1, slot2: Slot2, slot3: Slot3, slot4: Slot4, }) => {
                    return (
                        <div style={{}} className="row row-full-height row-no-padding row-col-separator-md">
                            <div className="col-md-3" >
                                <Slot1 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-md-3">
                                <Slot2 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-md-3">
                                <Slot3 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-md-3">
                                <Slot4 style={{ height: "100%", width: "100%" }} />
                            </div>
                        </div>
                    );
                },
            },
            GRD_3CM_NOPAD: {
                label: "GRD 3C Middle NOPAD",

                fields: {
                    leftColumn: {
                        type: "slot",
                        // allow: ["NEW_ContractParties", "NEW_ContractPrice", "NEW_ContractTimeline", "NEW_ProgramTimeline", "NEW_ContractPayments", "NEW_ContractActions"],
                    },
                    middleColumn: {
                        type: "slot",
                        // allow: ["NEW_ContractParties", "NEW_ContractPrice", "NEW_ContractTimeline", "NEW_ProgramTimeline", "NEW_ContractPayments", "NEW_ContractActions"],

                    },
                    rightColumn: {
                        type: "slot",
                        // allow: ["NEW_ContractParties", "NEW_ContractPrice", "NEW_ContractTimeline", "NEW_ProgramTimeline", "NEW_ContractPayments", "NEW_ContractActions"],

                    },
                },
                render: ({ leftColumn: LeftColumn, middleColumn: MiddleColumn, rightColumn: RightColumn }) => {
                    return (
                        <div style={{}} className="row row-full-height row-no-padding row-col-separator-md">
                            <div className="col-md-4" >
                                <LeftColumn style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-md-4">
                                <MiddleColumn style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-md-4">
                                <RightColumn style={{ height: "100%", width: "100%" }} />
                            </div>
                        </div>
                    );
                },
            },
            GRD_2CM_NOPAD: {
                label: "GRD 2C Middle NOPAD",

                fields: {
                    leftColumn: {
                        type: "slot",
                        // allow: ["NEW_ContractParties", "NEW_ContractPrice", "NEW_ContractTimeline", "NEW_ProgramTimeline", "NEW_ContractPayments", "NEW_ContractActions"],
                    },
                    rightColumn: {
                        type: "slot",
                        // allow: ["NEW_ContractParties", "NEW_ContractPrice", "NEW_ContractTimeline", "NEW_ProgramTimeline", "NEW_ContractPayments", "NEW_ContractActions"],

                    },
                },
                render: ({ leftColumn: LeftColumn, rightColumn: RightColumn }) => {
                    return (
                        <div style={{}} className="row row-full-height row-no-padding row-col-separator-md">
                            <div className="col-md-6" >
                                <LeftColumn style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-md-6">
                                <RightColumn style={{ height: "100%", width: "100%" }} />
                            </div>
                        </div>
                    );
                },
            },
            GRD_4CN_2CM_NOPAD: {
                label: "GRD 4C Normal 2C Middle NOPAD",
                fields: {
                    slot1: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],

                    },
                    slot2: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],

                    },
                    slot3: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],

                    },
                    slot4: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],
                    },
                },
                render: ({ slot1: Slot1, slot2: Slot2, slot3: Slot3, slot4: Slot4, }) => {
                    return (
                        <div style={{}} className="row row-full-height row-no-padding row-col-separator-md">
                            <div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                <Slot1 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                <Slot2 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                <Slot3 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                <Slot4 style={{ height: "100%", width: "100%" }} />
                            </div>
                        </div>
                    );
                },
            },
            GRD_4CW_2CN_NOPAD: {
                label: "GRD 4C Wide 2C Normal NOPAD",
                fields: {
                    slot1: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],

                    },
                    slot2: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],

                    },
                    slot3: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],

                    },
                    slot4: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],
                    },
                },
                render: ({ slot1: Slot1, slot2: Slot2, slot3: Slot3, slot4: Slot4, }) => {
                    return (
                        <div style={{}} className="row row-full-height row-no-padding row-col-separator-md">
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                <Slot1 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                <Slot2 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                <Slot3 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                <Slot4 style={{ height: "100%", width: "100%" }} />
                            </div>
                        </div>

                    );
                },
            },
            GRD_4CW_2CN: {
                label: "GRD 4C Wide 2C Normal",
                fields: {
                    slot1: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],

                    },
                    slot2: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],

                    },
                    slot3: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],

                    },
                    slot4: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],
                    },
                },
                render: ({ slot1: Slot1, slot2: Slot2, slot3: Slot3, slot4: Slot4, }) => {
                    return (
                        <div style={{}} className="row row-full-height">
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                <Slot1 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                <Slot2 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                <Slot3 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                <Slot4 style={{ height: "100%", width: "100%" }} />
                            </div>
                        </div>

                    );
                },
            },
            GRD_2Cx2C_M: {
                label: "GRD 2X2 Middle",
                fields: {
                    slot1: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],

                    },
                    slot2: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],

                    },
                    slot3: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],

                    },
                    slot4: {
                        type: "slot",
                        // allow: ["NEW_DonutEW", "NEW_DonutEWRisk", "NEW_DonutCEN", "NEW_DonutCENImplemented"],
                    },
                },
                render: ({ slot1: Slot1, slot2: Slot2, slot3: Slot3, slot4: Slot4, }) => {
                    return (
                        <div style={{}} className="row row-full-height">
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <Slot1 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <Slot2 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <Slot3 style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <Slot4 style={{ height: "100%", width: "100%" }} />
                            </div>
                        </div>

                    );
                },
            },
            GRD_2CW: {
                label: "GRD 2C Wide",
                fields: {
                    leftColumn: {
                        type: "slot",
                    },
                    rightColumn: {
                        type: "slot",
                    },
                },
                render: ({ leftColumn: LeftColumn, rightColumn: RightColumn }) => {
                    return (
                        <div className="row  row-full-height">
                            <div className="col-xl-6">
                                <LeftColumn style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-xl-6">
                                <RightColumn style={{ height: "100%", width: "100%" }} />
                            </div>
                        </div>
                    );
                },
            },
            GRD_2CN: {
                label: "GRD 2C Normal",
                fields: {
                    leftColumn: {
                        type: "slot",
                    },
                    rightColumn: {
                        type: "slot",
                    },
                },
                render: ({ leftColumn: LeftColumn, rightColumn: RightColumn }) => {
                    return (
                        <div className="row  row-full-height">
                            <div className="col-lg-6">
                                <LeftColumn style={{ height: "100%", width: "100%" }} />
                            </div>
                            <div className="col-lg-6">
                                <RightColumn style={{ height: "100%", width: "100%" }} />
                            </div>
                        </div>
                    );
                },
            },
            INFO_ContractParties: {
                inline: true,
                label: "[INFO] Contract Parties",
                fields: {
                    title: { type: "text" },
                },
                render: ({ children, title, puck }) => {
                    return (
                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid>
                                <ContractParties
                                    title={title}
                                    userProfile={props.userProfile}
                                    contract={props.contract}
                                    contractTemplate={props.contractTemplate}
                                    contractUsers={props.contractUsers}
                                />
                            </PortletBody>
                        </Portlet>

                    );
                },
            },
            INFO_ContractPrice: {
                inline: true,
                label: "[INFO] Contract Price",
                fields: {
                    title: { type: "text" },
                },
                render: ({ children, title, puck }) => {
                    return (
                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid>
                                <ContractPrice
                                    title={title}
                                    contract={props.contract}
                                    contractDashboard={props.contractDashboard}
                                    contractTemplate={props.contractTemplate}
                                    dashboardCurrencyCode={props.dashboardCurrencyCode}
                                />
                            </PortletBody>
                        </Portlet>
                    );
                },
            },
            INFO_MultipleContractPrice: {
                inline: true,
                label: "[INFO] Multiple Contract Price",
                fields: {
                    title: { type: "text" },
                },
                render: ({ children, title, puck }) => {
                    return (
                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid>
                                <MultipleContractPrice
                                    title={title}
                                    contract={props.contract}
                                    contractDashboard={props.contractDashboard}
                                    contractTemplate={props.contractTemplate}
                                />
                            </PortletBody>
                        </Portlet>
                    );
                },
            },
            INFO_ContractTimeline: {
                inline: true,
                label: "[INFO] Contract Timeline",
                fields: {
                    title: { type: "text" },
                },
                render: ({ children, title, puck }) => {
                    return (
                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid>
                                <ContractTimeline
                                    title={title}
                                    contractTemplate={props.contractTemplate}
                                    contractid={props.contract.contractid}
                                    startdate={props.contract.startdate}
                                    enddate={props.contract.completedate}
                                    currentenddate={props.contract.completiondate}
                                    actualcompletiondate={props.contract.actualcompletiondate}
                                    defectsdate={props.contract.defectsdate}
                                    globalResources={props.contractTemplate.resources}
                                />
                            </PortletBody>
                        </Portlet>
                    );
                },
            },
            INFO_ProgramTimeline: {
                inline: true,
                label: "[INFO] Program Timeline",
                fields: {
                    title: { type: "text" },
                },
                render: ({ children, title, puck }) => {
                    return (
                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid>
                                <ProgramTimeline
                                    title={title}
                                    contractid={props.contract.contractid}
                                    contractTemplate={props.contractTemplate}
                                    expectedcompletiondate={props.contract.expectedcompletiondate}
                                    dashboard={props.contractDashboard}
                                />
                            </PortletBody>
                        </Portlet>
                    );
                },
            },
            INFO_ContractPayments: {
                inline: true,
                label: "[INFO] Contract Payments",
                fields: {
                    title: { type: "text" },
                },
                render: ({ children, title, puck }) => {
                    return (
                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid>
                                <ContractPayments
                                    title={title}
                                    contract={props.contract}
                                    globalResources={props.contractTemplate.resources}
                                    dashboardCurrencyCode={props.dashboardCurrencyCode}
                                />
                            </PortletBody>
                        </Portlet>
                    );
                },
            },
            INFO_ContractNextPaymentActions: {
                inline: true,
                label: "[INFO] Contract Next Payment Actions",
                fields: {
                    title: { type: "text" },
                },
                render: ({ children, title, puck }) => {
                    return (
                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid>
                                <ContractNextPayment
                                    title={title}
                                    contract={props.contract}
                                    contractTemplate={props.contractTemplate}
                                />
                            </PortletBody>
                        </Portlet>
                    );
                },
            },
            INFO_MultipleContractPayments: {
                inline: true,
                label: "[INFO] Multiple Contract Payments",
                fields: {
                    title: { type: "text" },
                },
                render: ({ children, title, puck }) => {
                    return (
                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid>
                                <MultipleContractPayments
                                    title={title}
                                    contract={props.contract}
                                    globalResources={props.contractTemplate.resources}
                                />
                            </PortletBody>
                        </Portlet>
                    );
                },
            },
            INFO_ContractActions: {
                inline: true,
                label: "[INFO] Contract Actions",
                fields: {
                    title: { type: "text" },
                },
                render: ({ children, title, puck }) => {
                    return (
                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid>
                                <ContractActions
                                    title={title}
                                    contractid={props.contract.contractid}
                                    contract={props.contract}
                                    contractDashboard={props.contractDashboard}
                                    contractTemplate={props.contractTemplate}
                                    actions={props.actions}
                                />
                            </PortletBody>
                        </Portlet>
                    );
                },
            },
            CHART_EW: {
                inline: true,
                label: "[CHART] Early Warnings",
                render: ({ children, puck }) => {
                    const warningPalette = ['#e0440e', '#e6693e', '#ec8f6e'];
                    const { resources: globalResources } = props.contractTemplate;
                    const { WFG_101_TITLE: earlyWarningTitle } = props.contractTemplate.resources;
                    const dashboard = props.contractDashboard;
                    return (

                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid={true}>
                                <DonutChart2 title={earlyWarningTitle}
                                    data={[
                                        ['Notified By', 'Notification Count'],
                                        [globalResources.SUPPLIER_NAME, dashboard ? dashboard.earlywarningcontractorraised : 0],
                                        [globalResources.PM_NAME, dashboard ? dashboard.earlywarningpmraised : 0],
                                        [globalResources.CLIENT_NAME, dashboard ? dashboard.earlywarningclientraised : 0],
                                    ]}
                                    colors={warningPalette}
                                    viewURL={`/contract/${props.contract.contractid}/early-warning/register/list`}
                                />
                            </PortletBody>
                        </Portlet>

                    );
                },
            },
            CHART_EWRisk: {
                inline: true,
                label: "[CHART] Early Warnings Risks",
                render: ({ children, puck }) => {
                    const colorPalette = ['#B53737', '#e0440e', '#e6693e', '#ec8f6e', '#f3b49f', '#f6c7b6'];
                    const { resources: globalResources } = props.contractTemplate;
                    const dashboard = props.contractDashboard;
                    return (

                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid={true}>
                                <DonutChart2 title={props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.RISKS' })}
                                    data={[
                                        ['Risk', 'Count'],
                                        [props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.VERY_HIGH' }), dashboard ? dashboard.riskveryhigh : 0],
                                        [props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.HIGH' }), dashboard ? dashboard.riskhigh : 0],
                                        [props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.MEDIUM' }), dashboard ? dashboard.riskpriority : 0],
                                        [props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.LOW' }), dashboard ? dashboard.risklow : 0],
                                        [props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.VERY_LOW' }), dashboard ? dashboard.riskverylow : 0],
                                    ]}
                                    colors={colorPalette}
                                    viewURL={`/contract/${props.contract.contractid}/early-warning/register/list`}
                                />
                            </PortletBody>
                        </Portlet>

                    );
                },
            },
            CHART_CEN: {
                inline: true,
                label: "[CHART] Compensation Events",
                render: ({ children, puck }) => {
                    const colorPalette = ['#26E3E0', '#4ACADE', '#38A6D9', '#4076D9', '#3854BD'];
                    const { resources: globalResources } = props.contractTemplate;
                    const { WFG_103_TITLE: compensationTitle } = props.contractTemplate.resources;
                    const dashboard = props.contractDashboard;
                    return (
                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid={true}>
                                <DonutChart2 title={compensationTitle}
                                    data={[
                                        ['Notified By', 'Notification Count'],
                                        [globalResources.SUPPLIER_NAME, dashboard ? dashboard.compeventcontractorraised : 0],
                                        [globalResources.PM_NAME, dashboard ? dashboard.compeventpmraised : 0],
                                        [globalResources.CLIENT_NAME, dashboard ? dashboard.compeventclientraised : 0],
                                    ]}
                                    colors={colorPalette}
                                    viewURL={`/contract/${props.contract.contractid}/compensation-events/register/list`}
                                />
                            </PortletBody>
                        </Portlet>

                    );
                },
            },
            CHART_CENImplemented: {
                inline: true,
                label: "[CHART] Compensations Implemented",
                render: ({ children, puck }) => {
                    const colorPalette = ['#51C048', '#74CE6D', '#98DB92', '#BCE8B8'];
                    const { resources: globalResources } = props.contractTemplate;
                    const { WFG_103_TITLE: compensationTitle } = props.contractTemplate.resources;
                    const dashboard = props.contractDashboard;
                    return (

                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20, minWidth: 0, display: 'flex', justifyContent: 'space-between' }} className="kt-portlet--height-fluid kt-portlet--border-bottom-brand">
                            <PortletBody fluid={true}>
                                <DonutChart2 title={props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.IMPLEMENTED_CE' }, { ITEM_NAME: compensationTitle })}
                                    data={[
                                        ['Status', 'Notification Count'],
                                        [props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.QUOTE_ACCEPTED' }), dashboard ? dashboard.quoteimplemented : 0],
                                        [props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.PM_ASSESSMENT_MADE' }, { PM_ABBREVIATION: globalResources.PM_ABBREVIATION }), dashboard ? dashboard.assessmentmade : 0],
                                    ]}
                                    colors={colorPalette}
                                    viewURL={`/contract/${props.contract.contractid}/compensation-events/register-implemented/list`}
                                />
                            </PortletBody>
                        </Portlet>

                    );
                },
            },
            /////////////////////////////////////////////////////////////////////////////////////////////////
            ContractName: {
                inline: true,
                label: "Contract Name",
                fields: {
                    title: { type: "text" },
                },
                defaultProps: {
                    title: "{CONTRACT_NAME}",
                },
                render: ({ children, title, puck }) => {
                    return (
                        <Portlet ref={puck.dragRef} style={{ marginBottom: 20 }}>
                            <PortletBody style={{ padding: "1rem", textAlign: "left" }}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        textAlign: "left"
                                    }}
                                >
                                    <p
                                        style={{
                                            fontSize: "1.1rem",
                                            margin: 0,
                                            fontWeight: 500,
                                            color: "#3F96C4",
                                            lineHeight: "28px",
                                            flex: "1 1 auto"   // 👈 take remaining space (keeps left aligned)
                                        }}
                                    >
                                        {title.replace("{CONTRACT_NAME}", props.contract.name)}
                                    </p>
                                </div>
                            </PortletBody>
                        </Portlet>

                    );
                },
            },
            ContractCalendar: {
                label: "Contract Calendar",
                render: ({ children }) => {
                    return (
                        <Portlet fluidHeight={true} style={{ marginBottom: 20 }}>
                            {/* <PortletHeader title="Deadline Calendar" /> */}
                            <PortletBody>
                                <ConrtractCalendarAction
                                    lang={props.lang}
                                    contract={props.contract}
                                    manualActions={props.actions}
                                    contractTemplate={props.contractTemplate}
                                />

                            </PortletBody>
                        </Portlet>
                    );
                },
            },


        },
        // root: {
        //     render: ({ children }) => {
        //         return (
        //             <div>
        //                 {children}
        //             </div>

        //         );
        //     },
        // },
    };
    return config;
}

// Save the data to your database
const save = (data) => {
    Common.downloadFile({
        data: JSON.stringify(data, null, 2),
        fileName: 'DashboardConfig.json',
        fileType: 'text/json',
    });
};

const MasterTemplateDashboardDesigner = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    let importRef = useRef(null);
    let defaultData = props.template.dashboardDesign || DefaultDashboardDesign; // 
    const [data, setData] = useState(defaultData);
    const [puckRenderVersion, setPuckRenderVersion] = useState(1);
    const defaultTemp = TemplateHelper.getDefaultSanitizedTemplate();
    const dummyTemplate = adjustContractTemplate(dummyContract, defaultTemp, null, null, true);

    let config = getPuckDashboardRenderer({
        contract: dummyContract,
        contractTemplate: dummyTemplate,
        contractDashboard: dummyDashboard,
        dashboardCurrencyCode: defaultCurrencyCode,
        userProfile: props.userProfile,
        contractUsers: [],
        actions: dummyActions,
        intl: props.intl,
        lang: 'en',
    });

    const overrides = {
        headerActions: ({ children }) => {
            const clonedExportButton = React.cloneElement(children, { children: "Export Design", icon: null });
            // const clonedImportButton = React.cloneElement(clonedExportButton, { children: "Import Design", icon:null, onClick:()=>{console.log("test");} });
            // console.log(clonedExportButton);
            // return(TEST);
            // return (<>{clonedExportButton}</>);
            // return null;
            return (
                // <div id="mySTylingTest" style={{display:"flex",rowGap:8,}}>
                <Toolbar width={50} disabled={false}>
                    <ToolbarItem
                        key="exportDashboardDesign"
                        widget="dxButton"
                        location="after"
                        locateInMenu="always"
                        disabled={false}
                        options={{
                            text: "Export Design",
                            type: "default",
                            stylingMode: "outlined",
                            icon: "export",
                            onClick: clonedExportButton.props.onClick
                        }} />

                    <ToolbarItem
                        key="importDashboardDesign"
                        widget="dxButton"
                        location="after"
                        locateInMenu="always"
                        disabled={false}
                        options={{
                            text: "Import Design",
                            type: "default",
                            stylingMode: "outlined",
                            icon: "import",
                            onClick: () => {
                                if (importRef.current) {
                                    importRef.current.click();
                                }
                            }
                        }} />

                    <ToolbarItem
                        key="resetDashboardDesign"
                        widget="dxButton"
                        location="after"
                        locateInMenu="always"
                        disabled={false}
                        options={{
                            text: "Reset to Default",
                            type: "default",
                            stylingMode: "outlined",
                            icon: "refresh",
                            onClick: () => {
                                let newData = JSON.parse(JSON.stringify(DefaultDashboardDesign));
                                setData(newData);
                                props.onDataChanged(newData);
                                setPuckRenderVersion(puckRenderVersion + 1);
                            }
                        }} />

                </Toolbar>
                // </div>
            )
        },

    };
    let importFileSelected = async (e) => {
        if (e.stopPropagation) { e.stopPropagation(); }
        if (e.preventDefault) { e.preventDefault(); }
        if (e.target && e.target.files && e.target.files.length > 0) {
            var file = e.target.files[0];
            if (file) {
                try {
                    const text = await file.text();
                    const importedDesign = JSON.parse(text)
                    console.log(importedDesign)
                    setData(importedDesign);
                    props.onDataChanged(importedDesign);
                    setPuckRenderVersion(puckRenderVersion + 1);
                    enqueueSnackbar('Design successfully imported', { variant: 'success' });
                } catch (err) {
                    enqueueSnackbar("Error reading file", { variant: 'error', });
                    console.log(err.toString())
                }
                finally {
                    if (importRef.current) {
                        importRef.current.value = null;
                    }
                }
            }
        }
    };
    return (
        <>
            <input type='file' id='importDashboardDesignFile' accept='.json' ref={importRef} style={{ display: 'none' }} onChange={importFileSelected} />
            <Puck
                key={"PuckDesignerV" + puckRenderVersion}
                // ref={puckRef}//{(ref) => { puckRef = ref; }}
                // style={{ minHeight: 1500 }}
                overrides={overrides}
                iframe={{
                    enabled: true,
                    waitForStyles: false,
                }}
                headerTitle="Contract Dashboard"
                config={config}
                data={data}
                onPublish={save}
                onChange={props.onDataChanged}
            // ui={{ leftSideBarWidth: 250, rightSideBarVisible: false }}

            >
            </Puck>
        </>


    );

}

const mapStateToProps = (store) => ({
    userProfile: store.auth.userProfile,

});

export default injectIntl(withSnackbar(connect(mapStateToProps, null)(MasterTemplateDashboardDesigner)));